export const locale = {
    lang: 'en',
    data: {
        TIME_RANGE: {
            ELECTIVE: 'Elective',
            TODAY: 'Today',
            YESTERDAY: 'Yesterday',
            THIS_WEEK: 'This week',
            LAST_WEEK: 'Last week',
            THIS_MONTH: 'This month',
            LAST_MONTH: 'Last month'
        }
    }
};
